import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Blog from "../../components/blog/Blog";

function BlogPage({ setShow }) {
  return (
    <>
      <Helmet>
        <title>Blog | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Blog />
    </>
  );
}

export default BlogPage;
